import {FC, PropsWithChildren} from "react";

export enum ParagraphSize {
    BASE = 'text-xl',
    SMALL = 'text-sm',
    MEDIUM = 'text-base',
    LARGE = 'text-2xl'
}

export enum ParagraphColor {
    BLUE = 'text-[#4672c4]',
    BLACK = 'text-black',
    WHITE = 'text-white',
    RED = 'text-red-900',
}

export enum ParagraphWeight {
    NORMAL = 'font-normal',
    BOLD = 'font-bold',
    EXTRA_BOLD = 'font-extrabold',
}

interface ParagraphProps extends PropsWithChildren {
    size?: ParagraphSize;
    color?: ParagraphColor;
    weight?: ParagraphWeight;
    className?: string;
}

const Paragraph:FC<ParagraphProps> = (
    {
        children,
        size = ParagraphSize.BASE,
        color = ParagraphColor.BLUE,
        weight = ParagraphWeight.BOLD,
        className,
    }
) => {
    return (
        <div className={`${size} ${color} ${weight} ${className && className}`}>
            {children}
        </div>
    );
};

export default Paragraph;